import React, { ReactElement } from 'react';
import AlertDetailsForm from './AlertDetailsForm';
import { createStyles, makeStyles, Theme } from '@material-ui/core';
import { Dialog } from '@progress/kendo-react-dialogs';
import { useDispatch } from 'react-redux';
import { Dispatch } from 'redux';
import StringResourceManager from '../StringResourceManager';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    dialogTitle: {
      textAlign: 'center',
      fontSize: '1.5rem',
      color: '#23496B',
      fontWeight: 'bold',
    },
    box: {
      height: 60,
      display: 'flex',
      padding: theme.spacing(2),
      margin: theme.spacing(1),
    },
    spreadBox: {
      justifyContent: 'space-around',
      alignItems: 'center',
    },
    dialogAction: {
      height: '3rem',
      padding: theme.spacing(3),
    },
  })
);

interface Props {
  handleCloseDialog: (open: boolean) => void;
  alertIDs: number[];
}

const AlertDetailsDialog: React.FC<Props> = ({
  handleCloseDialog,
  alertIDs,
}): ReactElement => {
  const classes = useStyles();
  const dispatch: Dispatch<any> = useDispatch();

  const handleClose = () => {
    handleCloseDialog(false);
  };

  return (
    <Dialog
      onClose={handleClose}
      style={{ zIndex: 10000 }}
      title={
        <StringResourceManager
          stringKey="ALERT_DETAILS"
          style="dialogTitle"
          variant="h1"
        />
      }
      width="85vw"
      height="95vh"
    >
      <AlertDetailsForm alertIDs={alertIDs} closeForm={handleClose} />
    </Dialog>
  );
};

export default AlertDetailsDialog;
